/* eslint-disable no-param-reassign */

import Vue from 'vue';

export default {
  namespaced: true,

  state: {
    preferences: {
      hideDeviceIDs: [],
    },
  },

  getters: {
    preferences: state => state.preferences,
  },

  mutations: {
    set(state, data) {
      state.preferences = data.preferences;
    },

    hideDevice(state, data) {
      if (state.preferences.hideDeviceIDs === undefined) {
        Vue.set(state.preferences, 'hideDeviceIDs', []);
      }

      if (data.hide && !state.preferences.hideDeviceIDs.includes(data.id)) {
        state.preferences.hideDeviceIDs.push(data.id);
      }

      if (!data.hide && state.preferences.hideDeviceIDs.includes(data.id)) {
        state.preferences.hideDeviceIDs.splice(
          state.preferences.hideDeviceIDs.findIndex(a => a === data.id),
          1,
        );
      }
    },
  },

  actions: {
    fetch(ctx) {
      return Vue.prototype.$api.get('/me/preferences')
        .then((result) => {
          ctx.commit('set', { preferences: result.data });
        });
    },

    save(ctx) {
      return Vue.prototype.$api.put('/me/preferences', ctx.state.preferences);
    },

    hideAndSave(ctx, data) {
      ctx.commit('hideDevice', data);
      return ctx.dispatch('save');
    },
  },
};
